import { render, staticRenderFns } from "./DesignRirekishoHobbyPickerCard.vue?vue&type=template&id=1fca1048&scoped=true"
import script from "./DesignRirekishoHobbyPickerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekishoHobbyPickerCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DesignRirekishoHobbyPickerCard.vue?vue&type=style&index=0&id=1fca1048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fca1048",
  null
  
)

export default component.exports